import React from 'react';

export enum ACurrencySize {
  Medium = 'Medium',
  ExtraSmall = 'ExtraSmall',
}

export interface ACurrencyProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: ACurrencySize;
  text: string;
}
